import { render, staticRenderFns } from "./ModalFirstGreeting.vue?vue&type=template&id=602c2e16&scoped=true&"
import script from "./ModalFirstGreeting.vue?vue&type=script&lang=js&"
export * from "./ModalFirstGreeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602c2e16",
  null
  
)

export default component.exports